import { fundriseEfundReitId, growthTechReitId, ipoReitId, mergedEfundReitIds, ofundReitId } from '@constants';
import { FundriseRouteConfig } from 'vue-router';
import { investmentEntity } from '@store/modules/investment-entity';
import { ipo } from '@store/modules/ipo';
import { upgrade } from '@store/modules/upgrade';

const offeringsRoutes: Array<FundriseRouteConfig> = [
	{
		path: `/offerings`,
		name: 'offerings',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import(/* webpackChunkName: "offerings" */ '@views/offerings/offerings.vue')
	},
	{
		path: '/offerings/fundrise-ipo/view',
		name: 'offerings-ipo-landing',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		component: () =>
			import(/* webpackChunkName: "offerings-ipo-landing" */ '@views/offerings/offerings-ipo-landing.vue'),
		beforeEnter: async (to, from, next) => {
			if (investmentEntity.isIraEntity) {
				next({ name: 'account-overview', replace: true });
			} else if (investmentEntity.hasNeverBeenAnInvestor) {
				next({ name: 'user-overview', replace: true });
			} else {
				await ipo.fetchAndStoreMetadata();
				await ipo.fetchAndStoreCurrentPrincipal();

				if (!upgrade.dataLoaded) {
					await upgrade.fetchAndStoreServiceLevelUpgradeData();
				}
				next();
			}
		}
	},
	{
		path: '/offerings/fundrise-ipo/mobile-view',
		name: 'offerings-ipo-landing-mobile',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () =>
			import(/* webpackChunkName: "offerings-ipo-landing" */ '@views/offerings/offerings-ipo-landing-mobile.vue')
	},
	{
		path: `/offerings/opportunity-fund/view`,
		name: 'view-oppurtunity-fund-details',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		redirect: {
			name: 'view-offering-details',
			params: {
				offeringId: ofundReitId
			}
		}
	},
	{
		path: `/offerings/:offeringId/view`,
		name: 'view-offering-details',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: async (to, from, next) => {
			if (to.params.offeringId === ipoReitId) {
				next({ name: 'offerings-ipo-landing', replace: true });
			} else if (mergedEfundReitIds.includes(to.params.offeringId)) {
				next({ name: 'view-offering-details', params: { offeringId: fundriseEfundReitId } });
			} else {
				next();
			}
		},
		component: () =>
			import(
				/* webpackChunkName: "view-offering-details" */ '@src/views/offering-details/offering-details-wrapper.vue'
			)
	},
	{
		path: `/offerings/auth/:offeringId/view`,
		name: 'view-offering-details-authenticated',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		beforeEnter: async (to, from, next) => {
			next({
				name: 'view-offering-details',
				params: {
					offeringId: to.params.offeringId
				}
			});
		}
	},
	{
		path: `/reit/:offeringId/view`,
		name: 'view-reit-details-portfolio',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		redirect: { name: 'view-offering-details' }
	},
	{
		path: `/reits/:offeringId/view`,
		name: 'view-reit-details',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		redirect: { name: 'view-offering-details' }
	},
	{
		path: '/fundriseintervalfund-iframe-only/:offeringId',
		name: 'view-offering-details-iframe',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () =>
			import(
				/* webpackChunkName: "view-offering-details-iframe" */ '@src/views/offering-details/offering-details-wrapper.vue'
			)
	},
	{
		path: `/webview/offerings/${growthTechReitId}/view`,
		name: 'webview-growth-tech-landing',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import(/* webpackChunkName: "growth-tech-landing" */ '@views/webview/growth-tech-landing.vue')
	}
];

export default offeringsRoutes;
